<div class="table-responsive" *ngIf="listaResumen">

  <table class="table table-striped table-hover table-sm align-middle" style="max-width: 600px;">
    <thead class="grey lighten-2">
      <tr>
        <th scope="col">
          <mdb-checkbox (change)="checkAllChange($event)">Nro. ID Control efectivo</mdb-checkbox>
        </th>
        <!-- <th scope="col">Nro. ID Control efectivo</th> -->
        <th scope="col">Fecha</th>
        <th scope="col" class="text-right">Monto</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of listaResumen">
        <td>
          <mdb-checkbox [checked]="item.seleccion" (change)='checkDetalle(item)'>{{item.codigo}}</mdb-checkbox>
        </td>
        <!-- <td>{{item.codigo}}</td> -->
        <td>{{item.fecha_registro | fecha}}</td>
        <td  class="text-right">{{item.efectivo_recaudado | numerico}}</td>
      </tr>
    </tbody>
    <app-pagination [context]="paginationContext" (onPageChange)="handlePageChange($event)"
      *ngIf="listaResumen.length > 0">
    </app-pagination>
  </table>
</div>

<div class="row filtros-header" *ngIf="listaResumen" style="
      border-bottom: 1px solid #dee2e6;
      justify-content: start;
      align-items: center;">
  <div class="col">
    <h4>
      Datos del depositante
    </h4>
  </div>
</div>

<form [formGroup]='formDepositante' *ngIf="listaResumen" class="customForm">
  <div class="row">
    <div class="col" style="max-width: 300px;">
      <div class="md-form">
        <input value="" type="text" id="rutSolicitadoPor" class="form-control" placeholder="9.999.999-9" required
          #rutSolicitadoPor formatRut formControlName="rut" />
        <label for="rutSolicitadoPor">RUT</label>
      </div>
    </div>
    <div class="col" style="max-width: 300px;">
      <div class="md-form">
        <input value="" type="text" id="nombreDepo" class="form-control" placeholder="Nombre" required #nombreDepo
          formControlName="nombre" />
        <label for="nombreDepo">Nombre</label>
      </div>
    </div>
    <div class="col" style="max-width: 300px;">
      <div class="md-form mt-2">
        <mdb-select label="Banco destino" [options]="optionsBanco" placeholder="Banco destino" [filterEnabled]="true"
          formControlName="banco">
        </mdb-select>
      </div>
    </div>
    <div class="col" style="max-width: 300px;">
      <div class="md-form mt-2">
        <mdb-select label="Número de cuenta" [options]="optionsCuenta" placeholder="Número de cuenta" [filterEnabled]="true"
          formControlName="cuenta">
        </mdb-select>
      </div>
    </div>
    <div class="col" style="max-width: 300px;">
      <div class="md-form">
        <input value="" type="text" id="numeroCuenta" class="form-control" placeholder="Número de cuenta" required
          #numeroCuenta formControlName="numeroDeposito" monto />
        <label for="numeroCuenta">Número de deposito</label>
      </div>
    </div>
    <div class="col" style="max-width: 200px;">
      <div class="md-form">
        <mdb-date-picker [inline]="true" name="fechaDepo" [placeholder]="'Fecha depósito'" required
          formControlName="fechaDeposito">
        </mdb-date-picker>
      </div>
    </div>
  </div>


</form>

<div class="row" *ngIf="totalResumen !== null && listaResumen">
  <div class="col">
    <div class="table-responsive mt-1">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="blue lighten-5">
          <tr>
            <th style="text-align: right;">TOTAL</th>
            <td align="right"><strong>$ {{totalResumen | numerico}}</strong></td>
          </tr>
        </thead>

      </table>
    </div>
  </div>
</div>